import dynamic from 'next/dynamic';
import React, {ComponentType, Suspense, useRef} from 'react';
import {useViewport, withinOrWiderThan} from '@udemy-v2/react-layout-components';

import {CircularCarouselProps} from 'src/components/r3f/circular-carousel/circular-carousel';
import {Error} from 'src/components/error/error';
import {Loading} from 'src/components/loading/loading';

import {Navigation} from '../navigation/navigation';

import styles from './hero.module.scss';

const ErrorFallback: React.FC<CircularCarouselProps> = () => <Error />;

// ts-expect-error
const DynamicCircularCarousel: ComponentType<CircularCarouselProps> | ComponentType<object> =
    dynamic(
        async () => {
            const mod = await import('src/components/r3f/circular-carousel/circular-carousel');
            if ('Scene' in mod) {
                return mod.Scene;
            }
            return ErrorFallback;
        },
        {ssr: false, loading: Loading},
    );

const Title = () => {
    return (
        <div className={styles.heroTitle}>
            <div>Udemy</div>
            <div>Innovation Studio</div>
        </div>
    );
};

const MobileTitle = () => {
    return (
        <div className={`${styles.heroTitle} ${styles.mobileTitle}`}>
            <div>Udemy</div>
            <div>Innovation</div>
            <div>Studio</div>
        </div>
    );
};

const HeroContent = ({isWideViewport}: {isWideViewport: boolean}) => {
    return (
        <>
            <Navigation />
            <div className={styles.heroContent}>
                {isWideViewport ? <Title /> : <MobileTitle />}
                <Suspense fallback={<Loading />}>
                    <DynamicCircularCarousel
                        maxScale={isWideViewport ? 0.9 : 0.7}
                        radius={isWideViewport ? 0.8 : 0.5}
                    />
                </Suspense>
            </div>
        </>
    );
};

const Hero: React.FC = () => {
    const targetRef = useRef<HTMLDivElement>(null);
    const {range} = useViewport();
    const isWideViewport = range && withinOrWiderThan(range, 'xl');

    return (
        <section ref={targetRef} className={styles.heroSection}>
            {isWideViewport != null ? <HeroContent isWideViewport={isWideViewport} /> : null}
        </section>
    );
};

export {Hero};
